import type { AddToWatchlistModalPayload } from '../store/investor/reducer';
import { INVESTOR_ROUTES } from './constants/routesConst';

export function updateQueryParams(existingParams, paramSetterFunction, paramsToUpdate, location: any = {}) {
    const existingQParams = Object.fromEntries(existingParams.entries());
    Object.keys(existingQParams).forEach((key) => {
        existingParams.set(key, existingQParams[key]);
    });
    Object.keys(paramsToUpdate).forEach((key) => {
        existingParams.set(key, paramsToUpdate[key]);
    });
    if (location && location?.state) {
        paramSetterFunction?.(existingParams, { state: location.state });
    } else {
        paramSetterFunction?.(existingParams);
    }
}

export const ADD_LEAD_DEEP_LINK_QUERY = {
    OPEN: 'addLead',
    ENTITY_NAME: 'entityName',
    ENTITY_IDENTIFIER: 'entityIdentifier',
    SOURCE: 'addLeadSource',
} as const;

/** Leads-page URL that opens Add Lead prefilled with a company's name and CIN/LLPIN. */
export const buildAddLeadDeepLink = (entityName: string, entityIdentifier: string, source: string) =>
    `${INVESTOR_ROUTES.APP_SCAN}?${new URLSearchParams({
        [ADD_LEAD_DEEP_LINK_QUERY.OPEN]: 'true',
        [ADD_LEAD_DEEP_LINK_QUERY.ENTITY_NAME]: entityName,
        [ADD_LEAD_DEEP_LINK_QUERY.ENTITY_IDENTIFIER]: entityIdentifier,
        [ADD_LEAD_DEEP_LINK_QUERY.SOURCE]: source,
    })}`;

/** Add Lead modal data carried by an add-lead deep link, or null when the URL has none. */
export const readAddLeadDeepLink = (params: URLSearchParams): AddToWatchlistModalPayload['data'] | null =>
    params.get(ADD_LEAD_DEEP_LINK_QUERY.OPEN) === 'true'
        ? {
              prefillIdentifierDisplay: params.get(ADD_LEAD_DEEP_LINK_QUERY.ENTITY_NAME) ?? '',
              prefillIdentifierPayload: params.get(ADD_LEAD_DEEP_LINK_QUERY.ENTITY_IDENTIFIER) ?? '',
              source: params.get(ADD_LEAD_DEEP_LINK_QUERY.SOURCE) ?? undefined,
          }
        : null;
